var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoaderComponent',{attrs:{"value":_vm.promise,"theme":"default"}},[_c(_vm.tag,_vm._g(_vm._b({ref:"webcomponent",tag:"component",attrs:{"value":_vm.valueComp,"fetch-url":_vm.fetchUrl}},'component',_vm.$attrs,false),{
      ..._vm.filteredListeners,
      'webcomponent:update': $ev => _vm.update($ev),
    }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }